/**
 * @typedef {HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement} UserInputElement
 */

class CustomValidityForm extends HTMLElement {
    constructor() {
        super();

        this.addEventListener('input', this._onInput);
    }

    connectedCallback() {
        /**
         * @type {NodeListOf<UserInputElement>}
         */
        const targets = this.querySelectorAll('input, textarea, select');

        targets.forEach((target) => {
            this._updateValidity(target);
        });
    }

    /**
     * @param {InputEvent & {
     *     target: UserInputElement;
     * }} event
     */
    _onInput(event) {
        this._updateValidity(event.target);
    }

    /**
     * @param {UserInputElement} target
     */
    _updateValidity(target) {
        /**
         * @type {(keyof ValidityState)[]}
         */
        const names = [
            'patternMismatch',
            'rangeOverflow',
            'rangeUnderflow',
            'stepMismatch',
            'tooLong',
            'tooShort',
            'typeMismatch',
            'valueMissing',
        ];

        const nameOrUndefined = names.find((name) => {
            return target.validity[name];
        });

        target.title = target.dataset[nameOrUndefined] ?? '';
        target.setCustomValidity(target.title);
    }

    /**
     * @param {boolean} flag
     */
    setDisabled(flag) {
        /**
         * @type {NodeListOf<UserInputElement | HTMLButtonElement>}
         */
        const targets = this.querySelectorAll(
            'input, textarea, select, button'
        );

        targets.forEach((target) => {
            target.disabled = flag;
        });
    }
}

customElements.define('custom-validity-form', CustomValidityForm);
export default CustomValidityForm;
